'use client';

import React from 'react';
import { ThreadPost } from '@/interfaces/thread-post';

type Props = {
  thread: ThreadPost;
};

const truncate = (s: string, n = 300) => (s.length > n ? s.slice(0, n) + '…' : s);

const extractUrls = (text: string): string[] => {
  if (!text) return [];
  const urlRegex = /https?:\/\/[\w\-._~:\/?#[\]@!$&'()*+,;=%]+/g;
  const matches = text.match(urlRegex);
  return matches ? matches.map(m => m.trim()) : [];
};

const stripUrls = (text: string): string => {
  return text.replace(/https?:\/\/[\w\-._~:\/?#[\]@!$&'()*+,;=%]+/g, '').trim();
};

const ThreadCard = ({ thread }: Props) => {
  const urls = extractUrls(thread.content || '');
  const body = stripUrls(thread.content || '');

  return (
    <article className="thread-card border rounded p-4 shadow-sm bg-white">
      <div className="mb-3 text-sm text-gray-700 whitespace-pre-wrap">{truncate(body)}</div>
      <div className="text-xs text-gray-400 mb-3">{new Date(thread.createdAt).toLocaleString()}</div>

      {urls.length > 0 && (
        <div>
          <ul className="space-y-2">
            {urls.map((url: string, i: number) => (
              <li key={url}>
                <a href={url} target="_blank" rel="noopener noreferrer" className="text-sm hover:underline text-blue-600">
                  관련 포스팅 보러가기{urls.length > 1 ? ` ${i + 1}` : ''}
                </a>
              </li>
            ))}
          </ul>
        </div>
      )}
    </article>
  );
};

export default ThreadCard;
